import dynamic from 'next/dynamic';
import { resolvePath } from '@/utils/resolvePath';
const Logo = dynamic(() => import('../Logo'));

export default function ADNewLogo({ isMobile }: { isMobile: boolean }) {
    return (
        <Logo
            width={isMobile ? 'auto' : '5rem'}
            height={isMobile ? 'auto' : '2.5rem'}
            margin={!isMobile ? '0.5rem 0 0' : ''}
            flexShrink={'0'}
            LogoSvg={resolvePath('/images/ackodrive/ackodrive-new-logo.svg')}
        />
    );
}
